import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { CheckCircle2, Rocket, Lightbulb, Zap, Download, ShieldCheck } from 'lucide-react';
export function PremiumProduct() {
  const learnings = ['Cómo encontrar proveedores confiables en China sin cometer errores', 'Cómo negociar precios y reducir costos desde el inicio', 'Cómo crear tu nombre de marca y logo profesional', 'Cómo personalizar tu producto para diferenciarte', 'Cómo lanzar una marca que se vea confiable y lista para vender'];
  return <section className="bg-white py-24 px-6" data-id="element-265">
      <div className="max-w-4xl mx-auto" data-id="element-266">
        {/* Header */}
        <FadeIn data-id="element-267">
          <div className="text-center mb-16" data-id="element-268">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-brand-green/10 rounded-full mb-6" data-id="element-269">
              <Rocket className="w-8 h-8 text-brand-green" data-id="element-270" />
            </div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-brand-green mb-10" data-id="element-271">
              CREA TU MARCA EN AMAZON DESDE CHINA
            </h2>

            {/* Product Image */}
            <div className="mb-10 px-4" data-id="element-272">
              <img src="https://cdn.magicpatterns.com/uploads/wkmAtza51kc25BvybjSw4U/portada.png" alt="Crea tu Marca en Amazon desde China - Guía Premium" className="w-full max-w-2xl mx-auto h-auto rounded-2xl shadow-2xl object-contain" data-id="element-273" />
            </div>

            <p className="text-lg md:text-xl text-brand-text/70 leading-relaxed mb-6" data-id="element-274">
              Aprende cómo pasar de vender productos genéricos a construir una
              marca propia con proveedores verificables y crear un negocio real
              que puedas escalar.
            </p>

            <div className="flex items-center justify-center gap-3 mb-4" data-id="element-275">
              <Rocket className="w-5 h-5 text-brand-gold" data-id="element-276" />
              <p className="text-xl md:text-2xl font-serif text-brand-green font-semibold" data-id="element-277">
                ESTE ES EL SIGUIENTE NIVEL
              </p>
            </div>
            <p className="text-lg text-brand-text/60" data-id="element-278">
              Aquí es donde dejas de competir por precio… y empiezas a construir
              algo que realmente te pertenece.
            </p>

            <div className="mt-10" data-id="element-279">
              <Button onClick={() => window.open('https://43skvt-1y.myshopify.com/products/crea-tu-marca-en-amazon-desde-china', '_blank')} className="w-full sm:w-auto text-lg md:text-xl px-14 py-5" data-id="element-280">
                QUIERO EMPEZAR A CREAR MI MARCA
              </Button>
              <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 text-brand-text/50 text-xs mt-4" data-id="element-281">
                <span className="flex items-center gap-1.5" data-id="element-282">
                  <Zap className="w-3.5 h-3.5 text-brand-green" data-id="element-283" />
                  ACCESO INMEDIATO
                </span>
                <span className="flex items-center gap-1.5" data-id="element-284">
                  <Download className="w-3.5 h-3.5 text-brand-green" data-id="element-285" />
                  DESCARGA DIGITAL
                </span>
                <span className="flex items-center gap-1.5" data-id="element-286">
                  <ShieldCheck className="w-3.5 h-3.5 text-brand-green" data-id="element-287" />
                  COMPRA SEGURA
                </span>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Lo que aprenderás */}
        <FadeIn delay={0.1} data-id="element-288">
          <div className="bg-brand-beige rounded-2xl p-8 md:p-10 mb-10" data-id="element-289">
            <div className="flex items-center justify-center gap-3 mb-3" data-id="element-290">
              <Lightbulb className="w-6 h-6 text-brand-gold" data-id="element-291" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-292">
                LO QUE VES AQUÍ NO ES SOLO UNA GUÍA
              </h3>
            </div>
            <p className="text-center text-brand-text/60 mb-6" data-id="element-293">
              Es el sistema que te enseña a:
            </p>
            <div className="space-y-4 max-w-xl mx-auto" data-id="element-294">
              <div className="flex items-start gap-3" data-id="element-295">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-296" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-297">
                  Crear una marca desde cero
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-298">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-299" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-300">
                  Trabajar con proveedores reales en China
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-301">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-302" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-303">
                  Diferenciarte de la competencia
                </p>
              </div>
              <div className="flex items-start gap-3" data-id="element-304">
                <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-305" />
                <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-306">
                  Construir un negocio que pueda crecer
                </p>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Lo que aprenderás en la guía premium */}
        <FadeIn delay={0.15} data-id="element-307">
          <div className="bg-brand-beige rounded-2xl p-8 md:p-10" data-id="element-308">
            <div className="flex items-center gap-3 mb-6" data-id="element-309">
              <Rocket className="w-6 h-6 text-brand-gold" data-id="element-310" />
              <h3 className="text-xl md:text-2xl font-bold text-brand-green" data-id="element-311">
                LO QUE APRENDERÁS EN ESTA GUÍA PREMIUM
              </h3>
            </div>
            <div className="space-y-4" data-id="element-312">
              {learnings.map((item, index) => <div key={index} className="flex items-start gap-3" data-id="element-313">
                  <CheckCircle2 className="w-5 h-5 text-brand-green flex-shrink-0 mt-0.5" data-id="element-314" />
                  <p className="text-base md:text-lg text-brand-text/80 font-medium" data-id="element-315">
                    {item}
                  </p>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}